import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 *
 * **Migration Guide:**
 * Replace this component with standard HTML elements and the animation classes directly:
 *
 * ```tsx
 * // Before
 * <AnimatedContainer animationType={ANIMATION_TYPES.FADE_IN} delay={2}>
 *   Content
 * </AnimatedContainer>
 *
 * // After
 * <div
 *   className="animate-fade-in"
 * >
 *   Content
 * </div>
 * ```
 *
 * **Animation types mapping:**
 * - `ANIMATION_TYPES.NONE` → no class needed
 * - `ANIMATION_TYPES.FADE_IN` → `className="animate-fade-in"`
 * - `ANIMATION_TYPES.SLIDE_DOWN_FADE_IN` → `className="animate-slide-down-fade-in"`
 * - `ANIMATION_TYPES.EASE_IN_BG` → `className="animate-ease-in-bg"`
 * - `ANIMATION_TYPES.SLIDE_IN` → `className="animate-slide-in"`
 * - `ANIMATION_TYPES.SLIDE_IN_FADE_IN` → `className="animate-slide-in-fade-in"`
 *
 * **Important:** The delay value gets multiplied by 40ms in CSS and by default is 1: `calc(var(--animation-delay, 1) * 40ms)`
 *
 * **Examples:**
 * ```tsx
 * // Before
 * <AnimatedContainer
 *   as="section"
 *   animationType={ANIMATION_TYPES.SLIDE_DOWN_FADE_IN}
 *   delay={3}
 *   className="custom-class"
 * >
 *   Content
 * </AnimatedContainer>
 *
 * // After
 * <section
 *   className="animate-slide-down-fade-in custom-class"
 *   style={{'--animation-delay': 3}}
 * >
 *   Content
 * </section>
 * ```
 */ var ANIMATION_TYPES;
(function(ANIMATION_TYPES) {
    /** @deprecated Use no animation class instead */ ANIMATION_TYPES["NONE"] = "";
    /** @deprecated Use className="animate-fade-in" instead */ ANIMATION_TYPES["FADE_IN"] = "animate-fade-in";
    /** @deprecated Use className="animate-slide-down-fade-in" instead */ ANIMATION_TYPES["SLIDE_DOWN_FADE_IN"] = "animate-slide-down-fade-in";
    /** @deprecated Use className="animate-ease-in-bg" instead */ ANIMATION_TYPES["EASE_IN_BG"] = "animate-ease-in-bg";
    /** @deprecated Use className="animate-slide-in" instead */ ANIMATION_TYPES["SLIDE_IN"] = "animate-slide-in";
    /** @deprecated Use className="animate-slide-in-fade-in" instead */ ANIMATION_TYPES["SLIDE_IN_FADE_IN"] = "animate-slide-in-fade-in";
})(ANIMATION_TYPES || (ANIMATION_TYPES = {}));
/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use standard HTML elements with animation classes and CSS custom properties instead.
 * See the enum documentation above for migration examples.
 */ const AnimatedContainer = ({ as: Component = 'div', animationType = '', className, children, delay })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  AnimatedContainer component is deprecated and will be removed in a future version.\n' + 'Please migrate to using standard HTML elements with animation classes:\n' + `• Replace <AnimatedContainer animationType={ANIMATION_TYPES.FADE_IN} delay={${delay}}> with:\n` + `• <div className="${animationType}" style={{'--animation-delay': ${delay}}}>\n` + 'See component documentation for all animation type mappings.');
    }
    return jsx(Component, {
        className: classNames(className, {
            [animationType]: animationType
        }),
        style: animationType ? {
            '--animation-delay': delay
        } : undefined,
        children: children
    });
};

export { ANIMATION_TYPES, AnimatedContainer };
